import { render, staticRenderFns } from "./marcasAdd.vue?vue&type=template&id=b06122ac"
import script from "./marcasAdd.vue?vue&type=script&lang=js"
export * from "./marcasAdd.vue?vue&type=script&lang=js"
import style0 from "./marcasAdd.vue?vue&type=style&index=0&id=b06122ac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports